import { memo, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { INITIAL_DATA_GET } from '../apis';
import { actionLogOutUser, handleChangeProfileData } from '../redux/actions/pages/user/user';
import { handleChangeDataHeaderDesktop } from '../redux/actions/partials/header/headerDesktop';
import { handleChangeDataCategories } from '../redux/actions/categories';
import Root from "./root";
import apiRequest from '../utils/apiRequest';


const App = () => {
	
	const dispatch = useDispatch();

	const { token } = useSelector((state: any) => state.user);

	useEffect(() => {
        handleCheckedLoginAndOtherData();
        // eslint-disable-next-line
    }, [App]);

    const handleCheckedLoginAndOtherData = () => {

    	apiRequest({
		    dispatch,
		    endpoint: INITIAL_DATA_GET,
		    method: 'post',
            data: {width: window.innerWidth},
		    token: token,
		    onSuccess: (res: any) => {
                dispatch(handleChangeDataHeaderDesktop('topBanners', res.topSlider));
                dispatch(handleChangeDataHeaderDesktop('topSearchKeywords', res.topSearchKeywords));
                const updatedCategories = res.categories.map((cat: any, index: number) => ({
                    ...cat,
                    selected: index === 0 ? true : cat.selected || false
                }));
                dispatch(handleChangeDataCategories('categories', updatedCategories));
                if(res.user_info !== null)
                	dispatch(handleChangeProfileData(res.user_info));
                else
                	dispatch(actionLogOutUser());
		    },
	  	});

    };

	return (
        <div id={'app'} className={'rtl'}>
            <Root/>
        </div>
    )
}

export default memo(App);
